import { NgModule } from '@angular/core';

import { StaticContentComponent } from './static-content.component';
import { SharedModule } from '@app/shared';

@NgModule({
    imports: [SharedModule],
    declarations: [ StaticContentComponent],
    entryComponents: [StaticContentComponent],
    exports: [StaticContentComponent]
})
export class StaticContentModule {
}



// WEBPACK FOOTER //
// ./src/app/authorized/project/static-content/static-content.module.js